import React from 'react'
import { ListBullet, ListWrapper } from './styles'

export const listFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { field } = formatExtraData
  return (
    <ListWrapper>
      {row[field] && <ListBullet>{row[field]}</ListBullet>}
    </ListWrapper>
  )
}